<template>
    <div class="footer" :style="FooterStyle.style">
        <div class="left-info">
            <img :style="FooterStyle.logoStyle" :src="FooterStyle.logoStyle.icon" />
            
            <div>
                <div :style="FooterStyle.titleStyle.style">{{ FooterStyle.titleStyle.text }}</div>
                <div :style="FooterStyle.desStyle.style">{{ FooterStyle.desStyle.text }}</div>
            </div>
        </div>
        <div class="rignt-info" @click="FooterStyle.btnStyle.clickFun()" :style="FooterStyle.btnStyle.style">{{ FooterStyle.btnStyle.text }}</div>
        
    </div>
</template>

<script setup>
    import { ref } from 'vue';
    const FooterStyle = ref(window.globalConfig.footerStyle);
</script>

<style scoped lang="scss">
    .footer {
        padding: 0 12px;
        display: flex;
        align-items: center;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        gap: 12px;
        justify-content: space-between;
        box-sizing: border-box;
        line-height: 25px;
        .left-info{
           display: flex;
           align-items: center;
           gap: 8px;
           max-width: 80%;
        }
        .rignt-info {
            text-align: center;
            width: fit-content;
        }
    }
</style>